import { WORKFLOW_TRIGGERS } from 'modules/workflows/constants';
import {
  APICallEntrySource as APICallIcon,
  EventEntrySource as EventIcon,
  OtherJourneyEntrySource as OtherJourneyIcon,
  ScheduleEntrySource as ScheduleIcon,
} from 'ui/illustrations';
import { APICallEntrySource } from '../APICallEntrySource/APICallEntrySource';
import { EventEntrySource } from '../EventEntrySource';
import { OtherJourneyEntrySource } from '../OtherJourneyEntrySource/OtherJourneyEntrySource';
import { ScheduleEntrySource } from '../ScheduleEntrySource';

const ENTRY_SOURCE_TO_COMPONENT_MAP = {
  [WORKFLOW_TRIGGERS.TRIGGERED_CUSTOM_EVENT]: {
    component: EventEntrySource,
    radioIcon: EventIcon,
    radioLabel: 'Event occurs',
  },
  [WORKFLOW_TRIGGERS.SCHEDULED_RECURRING_LIST]: {
    component: ScheduleEntrySource,
    radioIcon: ScheduleIcon,
    radioLabel: 'Schedule',
  },
  [WORKFLOW_TRIGGERS.RECEIVED_API]: {
    component: APICallEntrySource,
    radioIcon: APICallIcon,
    radioLabel: 'API call',
  },
  [WORKFLOW_TRIGGERS.TRIGGERED_BY_WORKFLOW]: {
    component: OtherJourneyEntrySource,
    radioIcon: OtherJourneyIcon,
    radioLabel: 'Other journey',
  },
};

/**
 * Returns a component based off of node class
 * Defaults the event entry source to custom event
 */
export const getEntrySourceComponent = (nodeClass: string) =>
  ENTRY_SOURCE_TO_COMPONENT_MAP?.[nodeClass]?.component ||
  ENTRY_SOURCE_TO_COMPONENT_MAP?.[WORKFLOW_TRIGGERS.TRIGGERED_CUSTOM_EVENT].component;

/**
 * Returns radio options to be used in SourceSelect
 * Updates the event entry source to a previously saved node class
 */
export const getRadioOptions = (initialNodeClass: string, selectedNodeClass: string) =>
  Object.entries(ENTRY_SOURCE_TO_COMPONENT_MAP).map(([trigger, val]) => {
    const isEventRadio = trigger === WORKFLOW_TRIGGERS.TRIGGERED_CUSTOM_EVENT;

    // Check if the node class is anything other than Custom Event, Schedule, API Call, Other Journey
    const isOtherEventCurrentlySelected = !ENTRY_SOURCE_TO_COMPONENT_MAP[selectedNodeClass];
    const isOtherEventInitiallySelected = !ENTRY_SOURCE_TO_COMPONENT_MAP[initialNodeClass];

    let value = trigger;
    if (isEventRadio) {
      // Ex. if  "User profile update" is currently selected and user switches to Custom event
      // the Event radio should have new node class as value
      if (isOtherEventCurrentlySelected) value = selectedNodeClass;
      // Ex. if "User profile update" is initially selected and user switches to "Other journey" and back to "Event occurs"
      // the event radio should return to the saved node class
      if (!isOtherEventCurrentlySelected && isOtherEventInitiallySelected) value = initialNodeClass;
    }

    return {
      value,
      icon: val.radioIcon,
      label: val.radioLabel,
    };
  });
